<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn_160">
      <el-select
        class="select_btn_style"
        v-model="filters.displayClientTypes"
        placeholder="展示终端"
        multiple
        collapse-tags
      >
        <el-option
          v-for="(item, i) in typeList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.sharedStatus"
        placeholder="全部共享"
      >
        <el-option
          v-for="(item, i) in shareStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.onlineStatus"
        placeholder="全部状态"
      >
        <el-option
          v-for="(item, i) in onlineStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.name"
        placeholder="专题名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import butn from "@/components/button/index";
export default {
  components: { butn },
  data() {
    return {
      filters: {},
      onlineStatusData: [],
      shareStatusData: [],
      typeList: [],
    };
  },
  created() {
    this.getSysParamByTypes(["ONLINE_STATUS", "SHARED_SCREEN_STATUS", "DISPLAY_CLIENT_TYPE"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["ONLINE_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["SHARED_SCREEN_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["DISPLAY_CLIENT_TYPE"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.onlineStatusData = res.data["ONLINE_STATUS"];
        this.shareStatusData = res.data["SHARED_SCREEN_STATUS"];
        this.typeList = res.data["DISPLAY_CLIENT_TYPE"] || [];
      });
    },
    initData() {
      this.$emit("search", this.filters);
    },
    resetData() {
      this.filters = {};
      this.$emit("search", {});
    }
  }
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
</style>
